// The order of groups and fields inside groups is IMPORTANT. It will do the sorting of columns following the sequence from here.
// However, on UI they will be sorted alphabetically
export const entityGroupsExportFields = [
  {
    titleIntlKey: "entityGroups.columns.additionalNames.title",
    fields: [
      "additionalNamesNamePlaceLatin",
      "additionalNamesNamePlaceLocal",
      "additionalNamesNameShortLatin",
      "additionalNamesNameShortLocal",
    ],
  },
  {
    titleIntlKey: "entityGroups.columns.address.title",
    fields: [
      "addressAddress1",
      "addressAddress2",
      "addressAddress3",
      "addressCity",
      "addressCountryCode",
      "addressLatitude",
      "addressLongitude",
      "addressPostalCode",
      "addressState",
    ],
  },
  {
    titleIntlKey: "entityGroups.columns.entityGroup.title",
    fields: [
      "entityGroupId",
      "forceEntityGroupId",
      "externalId",
      "alternateVenueIds",
      "codeLatin",
      "codeLocal",
      "internationalReference",
      "nameFullLatin",
      "nameFullLocal",
      "status",
    ],
  },
  {
    titleIntlKey: "entityGroups.columns.colors.title",
    fields: ["colorsPrimary", "colorsSecondary", "colorsTertiary"],
  },
  {
    titleIntlKey: "entityGroups.columns.contacts.title",
    fields: ["contactsEmail", "contactsFax", "contactsPhone", "contactsPhoneSecondary"],
  },
  {
    titleIntlKey: "entityGroups.columns.details.title",
    fields: ["detailsFounded", "detailsSquadValue"],
  },
  {
    titleIntlKey: "entityGroups.columns.defaultVenue.title",
    fields: ["defaultVenueId", "defaultVenueExternalId", "defaultVenueName"],
  },
  {
    titleIntlKey: "entityGroups.columns.social.title",
    fields: ["socialFacebook", "socialInstagram", "socialTwitter", "socialWebsite", "socialWikipedia"],
  },
];

export const defaultEntityGroupsExportFieldNames = ["entityGroupId", "codeLocal", "nameFullLocal", "status"];
